const __request = require(`./__request`);
const recordCount = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/web/credit/creditNotRefund',
        data: data
    }
    return __request(pParameter)
}
export default recordCount